import { Stack, Title, Text, Group } from "@mantine/core";
import CreateRatePlanButton from "./RatePlanGrid/CreateRatePlanButton";

const HeaderTarifs = ({ openDrawer }) => {

  return (

    <Stack
      mb="lg"
      pb="md"
      style={{
        borderBottom: "1px solid #e9ecef"
      }}
    >

      <Group justify="space-between" align="flex-start">

        <div>

          <Title order={2}>
            Tarifs
          </Title>

          <Text c="dimmed" size="sm">
            Gérez vos plans tarifaires et configurez les prix pour chaque période
          </Text>

        </div>

        <CreateRatePlanButton openDrawer={openDrawer} />

      </Group>

    </Stack>

  )

}

export default HeaderTarifs